/**
 * Admin API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Organization } from './organization';
import { MessagingPhoneNumber } from './messaging-phone-number';
import { SelectedMessageConfigContent } from './selected-message-config-content';


export interface EPNIntegration { 
    domainName?: string;
    organization?: Organization;
    remindersOn?: boolean;
    dayOfRemindersOn?: boolean;
    recallsOn?: boolean;
    recallDayOf?: EPNIntegration.RecallDayOfEnum;
    recallWeekOf?: EPNIntegration.RecallWeekOfEnum;
    recallHourToRun?: string;
    timeBeforeType?: EPNIntegration.TimeBeforeTypeEnum;
    orderNotificationsOn?: boolean;
    selectedMessageConfigContent?: Array<SelectedMessageConfigContent>;
    messagingPhoneNumbers?: Array<MessagingPhoneNumber>;
}
export namespace EPNIntegration {
    export const RecallDayOfEnum = {
        Monday: 'MONDAY',
        Tuesday: 'TUESDAY',
        Wednesday: 'WEDNESDAY',
        Thursday: 'THURSDAY',
        Friday: 'FRIDAY',
        Saturday: 'SATURDAY',
        Sunday: 'SUNDAY'
    } as const;
    export type RecallDayOfEnum = typeof RecallDayOfEnum[keyof typeof RecallDayOfEnum];
    export const RecallWeekOfEnum = {
        First: 'FIRST',
        Second: 'SECOND',
        Third: 'THIRD',
        Fourth: 'FOURTH'
    } as const;
    export type RecallWeekOfEnum = typeof RecallWeekOfEnum[keyof typeof RecallWeekOfEnum];
    export const TimeBeforeTypeEnum = {
        Monthly: 'MONTHLY',
        Weekly: 'WEEKLY'
    } as const;
    export type TimeBeforeTypeEnum = typeof TimeBeforeTypeEnum[keyof typeof TimeBeforeTypeEnum];
}


